
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { AppRole } from "@/types/auth"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function capitalizeRole(role: AppRole | string): string {
  if (!role) return '';
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
}

export function generateFriendlyOrderNumber(orderId: string, createdAt?: string): string {
  // Take first 6 characters of UUID for uniqueness
  const shortId = orderId.slice(0, 6).toUpperCase();
  
  // If we have a creation date, use it for context
  if (createdAt) {
    const date = new Date(createdAt);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `ORD-${year}${month}-${shortId}`;
  }
  
  // Fallback to simple format
  return `ORD-${shortId}`;
}
